<div id="onboarding-audit-log-dialog">
    <!-- Sprinner -->
    @if(this.setSprinner()) {
    <div class="pias-spinner">
        <div class="spinner-border" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    </div>
    }

    <div id="dialog-title" mat-dialog-title>
        <div class="title-block">
            <span id="dialog-header">Onboarding History</span>
            <span class="dialog-subheader">
                {{ this.applicantName }}
                @if(this.designation) {
                <span class="subheader-sep">•</span> {{ this.designation }}
                }
            </span>
        </div>
        <button mat-icon-button mat-dialog-close matTooltip="Close" aria-label="Close onboarding history">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <mat-divider class="pias-divider"></mat-divider>

    <mat-dialog-content>
        @if(this.loadError()) {
        <div class="audit-placeholder error">
            <mat-icon>error_outline</mat-icon>
            <p>{{ this.loadError() }}</p>
        </div>
        } @else if(!this.setSprinner() && this.auditLog().length === 0) {
        <div class="audit-placeholder">
            <mat-icon>history_toggle_off</mat-icon>
            <p>
                No onboarding history recorded for this application yet.
                @if(this.currentStatus) {
                <br />It is currently at <strong>{{ this.getStatusLabel(this.currentStatus) }}</strong>.
                }
            </p>
        </div>
        } @else if(this.auditLog().length) {
        <mat-stepper orientation="vertical" class="audit-stepper" [disableRipple]="true">

            <!-- Every step carries the custom "audit" state so the circle shows the
                 status icon from the onboarding table instead of a step number. -->
            <ng-template matStepperIcon="audit" let-index="index">
                <mat-icon>{{ this.getStatusIcon(this.auditLog()[index]?.status || '') }}</mat-icon>
            </ng-template>

            @for(entry of this.auditLog(); track $index) {
            <mat-step state="audit" [editable]="false" [completed]="false">
                <ng-template matStepLabel>
                    <div class="step-label" [class.is-latest]="$index === this.auditLog().length - 1">
                        <div class="step-title">
                            <span class="status-chip" [ngClass]="this.getStatusClass(entry.status)">
                                Submitted For {{  this.getStatusLabel(entry.status) }}
                            </span>
                            @if($index === this.auditLog().length - 1) {
                            <!-- <span class="latest-badge">Current</span> -->
                            }
                        </div>

                        <div class="step-meta">
                            <span class="meta-item">
                                <mat-icon>event</mat-icon>
                                <span class="meta-key">Date:</span>
                                @if(this.formatTimestamp(entry.date); as timestamp) {
                                {{ timestamp }}
                                } @else {
                                <span class="meta-empty">—</span>
                                }
                            </span>
                            <span class="meta-item">
                                <mat-icon>person</mat-icon>
                                <span class="meta-key">Role:</span>
                                {{ getRoleLabel(entry.userRole)}}
                                <span class="meta-sep">|</span>
                                <span class="meta-key">User:</span>
                                {{ entry.userName }}
                            </span>
                        </div>
                    </div>
                </ng-template>
            </mat-step>
            }

        </mat-stepper>
        }
    </mat-dialog-content>
</div>
